'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  background: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  background: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n'], ['\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, _colors.grey);

var Img = _styledComponents2.default.img(_templateObject2);

var Image = function Image(_ref) {
  var src = _ref.src;
  return _react2.default.createElement(Container, null, _react2.default.createElement(Img, {
    src: src
  }));
};

Image.propTypes = {
  src: _propTypes2.default.string
};
exports.default = Image;